// Define the configuration object as the source of truth
export const featureFlags = {
    DISABLE_BILLING_SCAN: {
        name: 'Kills bill...ing',
        openInE2eTests: false,
        owner: 'leeor@sayanchor.com'
    },
    PROPOSAL_EXPIRATION_DATE_BULK_UPLOAD: {
        name: 'proposal expiration date bulk upload',
        openInE2eTests: false,
        owner: 'unset'
    },
    YEARLY_AUTOMATIC_SERVICE: {
        name: 'allow to set a yearly automatic service',
        openInE2eTests: true,
        owner: 'ben@sayanchor.com'
    },
    AUTOMATIC_STAGES: {
        name: 'per-stage scheduling on bill-in-stages services',
        openInE2eTests: true,
        owner: 'ben@sayanchor.com'
    },
    CONNECTED_APPS_PAGE: {
        name: 'new page that shows all connected integrations',
        openInE2eTests: true,
        owner: 'meital@sayanchor.com'
    },
    INVOICE_PDF_SCOUT: {
        name: 'use scout-pdf service to download invoice pdf',
        openInE2eTests: true,
        owner: 'ahuvi@sayanchor.com'
    },
    KYB_UPDATED_FLOW: {
        name: 'optimized KYB inquiry template (ANCR-869)',
        openInE2eTests: false,
        owner: 'anna.y@sayanchor.com'
    },
    INTERCOM_JWT_IDENTITY: {
        name: 'Use Intercom signed-JWT identity verification (replaces user_hash HMAC)',
        openInE2eTests: false,
        owner: 'leeor@sayanchor.com'
    },
    TEMPLATE_VARIABLES: {
        name: 'Template variables in Agreement Studio',
        owner: 'leeor@sayanchor.com',
        openInE2eTests: false
    },
    UPDATE_DEFAULT_TOS_FE: {
        name: 'content of Anchor default tos changed',
        openInE2eTests: false,
        owner: 'meital@sayanchor.com'
    },
    HELP_ME_DRAFT: {
        name: 'agentic proposal drafting pane in AgreementStudioProposalMode',
        openInE2eTests: false,
        owner: 'ahuvi@sayanchor.com'
    },
    EDIT_PROPOSAL_IN_PLACE: {
        name: 'edit proposal in place',
        openInE2eTests: true,
        owner: 'leeor@sayanchor.com'
    },
    REFERRAL_DASHBOARD_UPGRADE: {
        name: 'referral dashboard UI update with $100 credits',
        openInE2eTests: true,
        owner: 'guy@sayanchor.com'
    },
    SP_ONBOARDING_PHASE_1: {
        name: 'full-page SP onboarding wizard',
        openInE2eTests: false,
        owner: 'ben@sayanchor.com'
    },
    BILLING_SCHEDULE_GET_ALL_ENDPOINTS: {
        name: 'Use entity-specific GET endpoints for billing schedule',
        openInE2eTests: false,
        owner: 'idan@sayanchor.com'
    },
    ACTIVITY_LOG_V2: {
        name: 'use PostgreSQL-backed V2 activity log endpoint instead of Neo4j-backed V1',
        openInE2eTests: true,
        owner: 'elad@sayanchor.com'
    },
    ACTIVITY_LOG_DUAL_CALL: {
        name: 'dual-call old + new activity-log endpoints and post diffs to Slack (temporary parity-validation shim)',
        openInE2eTests: false,
        owner: 'elad@sayanchor.com'
    },
    AD_HOC_INVOICING: {
        name: 'ad-hoc invoicing',
        openInE2eTests: true,
        owner: 'aviv@sayanchor.com'
    },
    ME_V2_EXCLUDE_ACCOUNTANT_WORKSPACES: {
        name: 'use v2 /me endpoint that excludes accountant workspaces for faster loading',
        openInE2eTests: true,
        owner: 'danielc@sayanchor.com'
    },
    VOB_EARLY_BUSINESS_CREATION: {
        name: 'split VOB save into two steps: create business early, then update details',
        openInE2eTests: false,
        owner: 'guy.w@sayanchor.com'
    },
    VOB_REQUIRE_DETAILS_FROM_BUSINESS_DATA: {
        name: 'derive requireVendorDetailsCompletion from live business data instead of JWT claims',
        openInE2eTests: true,
        owner: 'ben@sayanchor.com'
    },
    CUSTOM_PAGES: {
        name: 'Custom pages in proposals and agreements',
        openInE2eTests: false,
        owner: 'anna.y@sayanchor.com'
    },
    CUSTOM_PAGES_AMENDMENTS: {
        name: 'Editing custom pages on signed agreements via amendments',
        openInE2eTests: false,
        owner: 'anna.y@sayanchor.com'
    },
    HEAP_BI_MIRROR: {
        name: 'mirror BI events to Heap for product analytics',
        openInE2eTests: false,
        owner: 'guy.w@sayanchor.com'
    },
    LANGUAGES: {
        name: 'Enable the language switcher (English/Spanish) in the user menu',
        openInE2eTests: false,
        owner: 'aviv@sayanchor.com'
    },
    PAYOUTS_EXTERNAL_API: {
        name: 'move the FE to use the new payout endpoint',
        openInE2eTests: false,
        owner: 'meital@sayanchor.com'
    },
    EXTERNAL_INVOICES_ENDPOINT: {
        name: 'move the FE to use the new invoice endpoints',
        openInE2eTests: false,
        owner: 'meital@sayanchor.com'
    },
    SERVICE_LEVEL_TERMS: {
        name: 'per-service legal terms rich text field',
        openInE2eTests: false,
        owner: 'aviv@sayanchor.com'
    },
    ENABLE_CLAUDE_CONNECTOR: {
        name: 'Claude Connector OAuth flow and consent page',
        openInE2eTests: false,
        owner: 'idan.s@sayanchor.com'
    },
    NOTIFICATION_CONTENT_CUSTOMIZATION: {
        name: 'Customized Notifications Content',
        openInE2eTests: true,
        owner: 'daniel@sayanchor.com'
    },
    INVOICE_DASHBOARD_METRICS: {
        name: 'invoice dashboard metrics cards with customization',
        openInE2eTests: false,
        owner: 'ben@sayanchor.com'
    },
    UPDATE_DEFAULT_AGREEMENT_TITLE: {
        name: 'rename the default agreement title from "Untitled agreement" to "Agreement"',
        openInE2eTests: true,
        owner: 'guy.w@sayanchor.com'
    },
    RELATIONSHIP_PDF_SCOUT: {
        name: 'use scout-pdf service to download relationship pdf',
        openInE2eTests: true,
        owner: 'guy.w@sayanchor.com'
    },
    AGREEMENTS_CSV_EXPORT_V2: {
        name: 'agreements dashboard CSV export with services (one row per service)',
        openInE2eTests: true,
        owner: 'leeor@sayanchor.com'
    },
    BILL_MODAL_V2: {
        name: 'redesigned bill client modal (V2)',
        openInE2eTests: true,
        owner: 'anna.y@sayanchor.com'
    },
    SHOW_ZAPIER_V2_API_KEY_GENERATION: {
        name: 'Zapier integration popup directs users to the general Anchor API Keys page (v2 Zapier app) instead of the legacy zapier-specific endpoint',
        openInE2eTests: false,
        owner: 'guy@sayanchor.com'
    },
    DELETE_PROPOSAL_TEMPLATE_V2: {
        name: 'use v2 DELETE /proposal-templates/:id endpoint with vendor-ownership check instead of the legacy POST /proposal-templates/:id/delete',
        openInE2eTests: true,
        owner: 'idan.s@sayanchor.com'
    },
    ENABLE_KILL_ACCOUNTANT_ACCESS_FE: {
        name: 'kill accountant access (FE) — replace request/approve UI with view-only client-portal session',
        openInE2eTests: true,
        owner: 'reut@sayanchor.com'
    },
    ENABLE_DRAFTS_AI_SEARCH: {
        name: 'natural-language drafts search input + chips on the drafts dashboard (ANCR-36)',
        openInE2eTests: false,
        owner: 'idan.s@sayanchor.com'
    },
    PING_INTEGRATION: {
        name: 'Ping integration card on Available Apps page (Communications section)',
        openInE2eTests: false,
        owner: 'leeor@sayanchor.com'
    }
};
export const FeatureFlag = Object.keys(featureFlags).reduce((acc, key)=>{
    acc[key] = key;
    return acc;
}, {});
